module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-check-icon",
    on: {
      "click": function($event) {
        _vm.value = !_vm.value
      }
    }
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'default' && _vm.value),
      expression: "type === 'default' && value"
    }],
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'plain' && _vm.value),
      expression: "type === 'plain' && value"
    }],
    attrs: {
      "type": "success_circle"
    }
  }), _vm._v(" "), _c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }],
    attrs: {
      "type": "circle"
    }
  }), _vm._v(" "), _c('span', [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ce6e64"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/check-icon/index.vue
// module id = 519
// module chunks = 4